// « La Veillée » — the suite-wall projection edition (`?display=conte`):
// a projector shows true black everywhere except a giant open book narrated
// by Médard's voice. See pages/ProjectionConteScreen.jsx.
export const PROJECTION = {
    screen: 'projection-screen',        // root of the veillée edition
    loading: 'projection-loading',      // « le vestibule » — the lit waiting plate
    loadingSlow: 'projection-loading-slow', // …and its « the library is taking its time » line
    error: 'projection-error',          // the book would not open — OK / tap retries
    start: 'projection-start',          // the « Commencer la veillée » navy plate
    book: 'projection-book',            // the open spread
    pageLeft: 'projection-page-left',   // text page (title, prose, indicator)
    pageText: 'projection-page-text',   // the planche prose block
    pageRight: 'projection-page-right', // plate page (engraving or ornament)
    art: 'projection-art',              // engraved plate <img>
    lueur: 'projection-lueur',          // one declared halo on the plate (« les lueurs »)
    ornament: 'projection-ornament',    // fallback house ornament (text-only books)
    indicator: 'projection-indicator',  // « Page n / total » micro-line
    leVrai: 'projection-le-vrai',       // closing credits page (Loi 2)
    ended: 'projection-ended',          // « La veillée est terminée » + replay hint
    endedVeil: 'projection-ended-veil', // …the darkened wash that makes it legible on paper
    library: 'projection-library',      // the shelf — choose your story (no ?conte=)
    libraryItem: 'projection-library-item', // one book cover card on the shelf
    intro: 'projection-intro',          // the owner's library film, once per session
    sealed: 'projection-sealed',        // the « à paraître » spines row (Loi 1: real titles)
    rite: 'projection-rite',            // the opening rite's candle-flare bloom
    voice: 'projection-voice',          // the shelf's narration state line (voix / silence)
    voiceNotice: 'projection-voice-notice', // the in-book whisper when the voice is switched
    descente: 'projection-descente',    // « La Descente » — the scrubbed crane dive (◄ ► / wheel)
    descenteHint: 'projection-descente-hint', // the bottom whisper — fades after the first notch
    crash: 'projection-crash',          // the wall's own error boundary — Médard's plate, lit
    crashReload: 'projection-crash-reload', // …its ONE calm action (≥44 px, a phone has no OK key)
    crashDetail: 'projection-crash-detail', // …and its technical line, ONLY under ?debug=1
    turnPrev: 'projection-turn-prev',   // « le livre dans la main » — the previous-leaf tap zone
    turnNext: 'projection-turn-next',   // …and the next-leaf one (single page only: a wall has no finger)
    diag: 'projection-diag',            // « le mur dit ce qu'il a » — the ?debug=1 panel
    diagBranch: 'projection-diag-branch', // the central intelligence: which branch is rendering
    diagLayout: 'projection-diag-layout', // …and WHICH BOOK: double spread, or the single page
    diagPointer: 'projection-diag-pointer', // …and WHO holds the screen: a finger, or a remote
    diagVrai: 'projection-diag-vrai',   // …and what the credits split did: faces, fill, ORPHANS
    facingLeaf: 'projection-facing-leaf', // the sliver of the page opposite (single page only)
};
